import { TranslateLoader } from '@ngx-translate/core';
import { of } from 'rxjs';
import { join } from 'path';
import { readFileSync, existsSync } from 'fs';

export class ServerTranslateLoader implements TranslateLoader {
  constructor(private prefix = './browser/assets/i18n', private suffix = '.json') { }

  getTranslation(lang: string) {
    let pathI18n = join(process.cwd(), this.prefix, `${lang}${this.suffix}`);
    if (!existsSync(pathI18n)) {
      // Fallback for development environment.
      pathI18n = join(process.cwd(), 'dist', this.prefix, `${lang}${this.suffix}`);
    }
    const data = JSON.parse(readFileSync(pathI18n, 'utf8'));

    return of(data);
  }
}
